import createIcon from '../../createIcon';

/**
 * @component @name CameraRoll
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQgNS41QzE0IDQuNCAxMy4xIDMuNSAxMiAzLjVIMTFWMi41QzExIDEuOTUgMTAuNTUgMS41IDEwIDEuNUg2QzUuNDUgMS41IDUgMS45NSA1IDIuNVYzLjVINEMyLjkgMy41IDIgNC40IDIgNS41VjIwLjVDMiAyMS42IDIuOSAyMi41IDQgMjIuNUgxMkMxMy4xIDIyLjUgMTQgMjEuNiAxNCAyMC41SDIyVjUuNUgxNFpNMTIgMTguNUgxMFYxNi41SDEyVjE4LjVaTTEyIDkuNUgxMFY3LjVIMTJWOS41Wk0xNiAxOC41SDE0VjE2LjVIMTZWMTguNVpNMTYgOS41SDE0VjcuNUgxNlY5LjVaTTIwIDE4LjVIMThWMTYuNUgyMFYxOC41Wk0yMCA5LjVIMThWNy41SDIwVjkuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CameraRoll = createIcon('CameraRoll', [
  [
    'path',
    {
      d: 'M14 5.5C14 4.4 13.1 3.5 12 3.5H11V2.5C11 1.95 10.55 1.5 10 1.5H6C5.45 1.5 5 1.95 5 2.5V3.5H4C2.9 3.5 2 4.4 2 5.5V20.5C2 21.6 2.9 22.5 4 22.5H12C13.1 22.5 14 21.6 14 20.5H22V5.5H14ZM12 18.5H10V16.5H12V18.5ZM12 9.5H10V7.5H12V9.5ZM16 18.5H14V16.5H16V18.5ZM16 9.5H14V7.5H16V9.5ZM20 18.5H18V16.5H20V18.5ZM20 9.5H18V7.5H20V9.5Z',
      key: '4a7wjt',
    },
  ],
]);

export default CameraRoll;
